import get from 'lodash/get';
import { createSelector } from 'reselect/lib/index';
import { COMMUNITIES_USER_ROLES } from '../../../constants';
import { selectAcceptDeclinePending } from './selectors';

export const currentCommunityInfoSelector = state =>
  get(state, 'communities.currentCommunityInfo');
export const currentCommunityPostsListSelector = state =>
  get(state, 'communities.postsList');

export const sendingCurrentCommunityInfoSelector = createSelector(
  currentCommunityInfoSelector,
  request => get(request, 'sending', false),
);
export const selectCurrentCommunityDisabled = createSelector(
  currentCommunityInfoSelector,
  request => get(request, 'disabled', false),
);

export const isCurrentCommunityModeratorSelector = createSelector(
  currentCommunityInfoSelector,
  request =>
    get(request, 'currentUserRole', null) === COMMUNITIES_USER_ROLES.MODERATOR,
);

export const isCurrentCommunityMemberSelector = createSelector(
  currentCommunityInfoSelector,
  request =>
    get(request, 'currentUserRole', null) === COMMUNITIES_USER_ROLES.MEMBER,
);

export const currentCommunitySelector = createSelector(
  currentCommunityInfoSelector,
  request => get(request, 'id', null),
);

export const currentCommunityScrollStatusSelector = state =>
  get(state, 'communities.currentCommunityScrollStatus');

export const currentCommunityScrollSelector = createSelector(
  currentCommunityScrollStatusSelector,
  state => get(state, 'scrolled', false),
);

export const currentCommunityTemporaryPostsSelector = createSelector(
  currentCommunityScrollStatusSelector,
  state => get(state, 'temporaryPostList', []),
);

export const selectAcceptDeclineDisabledState = createSelector(
  selectCurrentCommunityDisabled,
  selectAcceptDeclinePending,
  (communityDisabled, inviteDisabled) => communityDisabled || inviteDisabled,
);



// WEBPACK FOOTER //
// ./src/redux/communities/selectors/currentCommunity.js